import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { ZodExtended } from "@/data/zod.extended";
import { UserModels } from "./user.models";

export namespace UserApi {
export const get = () => { 
    return AppRestClient.get( 
        { resSchema: UserModels.UserAccountResponseSchema }, 
        `/user/me`,
        
    )
};

export const getNotificationPreferences = () => { 
    return AppRestClient.get( 
        { resSchema: UserModels.NotificationPreferencesResponseDtoSchema }, 
        `/user/me/notification-preferences`,
        
    )
};

export const updateNotificationPreferences = (data: UserModels.UpdateNotificationPreferencesDto, ) => { 
    return AppRestClient.patch( 
        { resSchema: UserModels.NotificationPreferencesResponseDtoSchema }, 
        `/user/me/notification-preferences`,
        ZodExtended.parse(UserModels.UpdateNotificationPreferencesDtoSchema, data)
, 
        
    )
};

export const verifySignin = () => { 
    return AppRestClient.post( 
        { resSchema: UserModels.UserAccountResponseSchema }, 
        `/user/signin/verify`,
        
    )
};

export const verifySignup = () => { 
    return AppRestClient.post( 
        { resSchema: UserModels.UserAccountResponseSchema }, 
        `/user/signup/verify`,
        
    )
};

export const verifySSO = () => { 
    return AppRestClient.post( 
        { resSchema: UserModels.UserAccountResponseSchema }, 
        `/user/sso/verify`,
        
    )
};

}
